module.exports = "- Keytip sequences can be duplicated as long as none of their siblings have the same sequence\n"